var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 8,
    viewBox: "0 0 32 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7447 4.35355C31.9399 4.15829 31.9399 3.84171 31.7447 3.64645L28.5627 0.464466C28.3674 0.269204 28.0508 0.269204 27.8556 0.464466C27.6603 0.659728 27.6603 0.976311 27.8556 1.17157L30.684 4L27.8556 6.82843C27.6603 7.02369 27.6603 7.34027 27.8556 7.53553C28.0508 7.7308 28.3674 7.7308 28.5627 7.53553L31.7447 4.35355ZM0.391113 4.5L31.3911 4.5V3.5L0.391113 3.5L0.391113 4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.af2d0bb9550bbf2057ccd1440af86ee0.svg";
export { ForwardRef as ReactComponent };